import { fetchFromAPI } from 'utils/api';

function hasUserFilters(params) {
  return Array.isArray(params?.filters) && params.filters.length > 0;
}

function buildGetParams(params) {
  if (!params) return params;
  const safeParams = { ...params };
  if (!hasUserFilters(safeParams)) delete safeParams.filters;
  return safeParams;
}

export function fetchBarnSheetsGroups(params) {
  return fetchFromAPI('/barnsheets/pig_groups', { params }).catch((errors) => {
    throw errors;
  });
}

export function downloadBarnSheetsGroupsCSV(params) {
  return fetchFromAPI('/barnsheets/pig_groups.csv', { blob: true, params })
    .catch((errors) => {
      throw errors;
    });
}

export function applyBarnSheetsGroupsFilter(params) {
  return fetchFromAPI('/barnsheets/pig_groups/filter', { method: 'post', body: JSON.stringify(params) })
    .catch((errors) => {
      throw errors;
    });
}

export function downloadBarnSheetsGroupsFilterCSV(params) {
  return fetchFromAPI('/barnsheets/pig_groups/filter.csv', { method: 'post', blob: true, body: JSON.stringify(params) })
    .catch((errors) => {
      throw errors;
    });
}

export function fetchBarnSheetsGroupDiagnoses(pigGroupId, params) {
  return fetchFromAPI(`/barnsheets/pig_groups/${pigGroupId}/diagnoses`, { params }).catch((errors) => {
    throw errors;
  });
}

export function fetchBarnSheetsGroupPigGroupDiagnoses(pigGroupId, params) {
  return fetchFromAPI(`/barnsheets/pig_groups/${pigGroupId}/pig_group_diagnoses`, { params }).catch((errors) => {
    throw errors;
  });
}

export function deleteBarnSheetsGroupPigGroupDiagnosis(pigGroupId, diagnosisId) {
  return fetchFromAPI(`/barnsheets/pig_groups/${pigGroupId}/pig_group_diagnoses/${diagnosisId}`, { method: 'delete' })
    .catch((errors) => {
      throw errors;
    });
}

export function downloadBarnSheetsGroupsMortalitiesCSV(params) {
  const endpoint = '/csv/barnsheets/pig_groups/mortalities_index';
  const requestOptions = hasUserFilters(params)
    ? { method: 'post', blob: true, body: JSON.stringify(params) }
    : { blob: true, params: buildGetParams(params) };

  return fetchFromAPI(endpoint, requestOptions).catch((errors) => {
    throw errors;
  });
}

export function downloadBarnSheetsGroupsMovementsCSV(params) {
  const endpoint = '/csv/barnsheets/pig_groups/pig_migrations_index';
  const requestOptions = hasUserFilters(params)
    ? { method: 'post', blob: true, body: JSON.stringify(params) }
    : { blob: true, params: buildGetParams(params) };

  return fetchFromAPI(endpoint, requestOptions).catch((errors) => {
    throw errors;
  });
}

export function downloadBarnSheetsGroupsTreatmentsCSV(params) {
  const endpoint = '/csv/barnsheets/pig_groups/treatment_products_index';
  const requestOptions = hasUserFilters(params)
    ? { method: 'post', blob: true, body: JSON.stringify(params) }
    : { blob: true, params: buildGetParams(params) };

  return fetchFromAPI(endpoint, requestOptions).catch((errors) => {
    throw errors;
  });
}

export function downloadBarnSheetsGroupsSurveysCSV(params) {
  const endpoint = '/csv/barnsheets/pig_groups/surveys_index';
  const requestOptions = hasUserFilters(params)
    ? { method: 'post', blob: true, body: JSON.stringify(params) }
    : { blob: true, params: buildGetParams(params) };

  return fetchFromAPI(endpoint, requestOptions).catch((errors) => {
    throw errors;
  });
}

export function downloadBarnSheetsGroupsDiagnosesCSV(params) {
  const endpoint = '/csv/barnsheets/pig_groups/diagnoses_index';
  const requestOptions = hasUserFilters(params)
    ? { method: 'post', blob: true, body: JSON.stringify(params) }
    : { blob: true, params: buildGetParams(params) };

  return fetchFromAPI(endpoint, requestOptions).catch((errors) => {
    throw errors;
  });
}
